
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 23H1.7L18.85 5.87l-.12 2.6a.5.5 0 00.48.53h.11a.5.5 0 00.5-.48l.18-4a.54.54 0 00-.02-.16l-.01-.04a.5.5 0 00-.11-.17.52.52 0 00-.18-.12h-.01a.51.51 0 00-.18-.03h-.1l-4 .19a.5.5 0 00.04 1h.09l2.62-.13L1 22.2V.5a.5.5 0 00-1 0v22.73a.5.5 0 00.05.62.5.5 0 00.36.15H23.5a.5.5 0 000-1z"}}),_c('path',{attrs:{"d":"M6.43 13.99a1 1 0 10-1.42 0 1 1 0 001.42 0z"}}),_c('circle',{attrs:{"cx":"6.06","cy":"8","r":"1"}}),_c('path',{attrs:{"d":"M12.05 8.37a1 1 0 10-1.41 0 1 1 0 001.41 0z"}}),_c('circle',{attrs:{"cx":"13.48","cy":"15.42","r":"1"}}),_c('path',{attrs:{"d":"M12.44 20a1 1 0 101.41 0 1 1 0 00-1.41 0zm-5.29.34a1 1 0 101.41 0 1 1 0 00-1.4 0zm10.91-5.96a1 1 0 101.42 0 1 1 0 00-1.42 0z"}})])
          )
        }
      }
    